var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{key:_vm.iframeKey,staticStyle:{"width":"100%","height":"90vh","border":"0"},attrs:{"src":`//wx.rennengda.com/quest/?questcode=${_vm.questCode}&system=consultStudent`,"id":"myIframe"}})
}
var staticRenderFns = []

export { render, staticRenderFns }